export default "__VITE_ASSET__CTWOxfgM__"